import styled, { css } from 'vue-styled-components';
import * as C from '@/components/Dashboard/common/WidgetSettingPanel/options/styles';
import { COLORS } from '@styles/common.styled';
import { ActionButton } from '@/components/Common/Dialog';
import { FLEX_COLUMN_DIV } from '@/styles/common.styled.component';

export const TitleWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

export const SelectedCountBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border-radius: 2px;
    background: #d7e9ff;
    color: #3c464f;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    padding: 1px 5px;

    .selected-count-info-icon {
        width: 12px;
        height: 12px;
        fill: #6e767d;
    }
`;

export const SelectedCountNumber = styled.span`
    color: #1557d9;
`;

export const ContentWrapper = styled(FLEX_COLUMN_DIV)`
    flex: 1;
`;

export const SettingsWrapper = styled.div`
    margin-bottom: 20px;
`;

export const Description = styled.p`
    width: 100%;
    color: #2a333d;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin: 0;
`;

export const LegacyNoteWrapper = styled.div`
    margin-top: 16px;
    width: 100%;
    background-color: #f4f6f8;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const LegacyNoteHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const LegacyNoteTitle = styled.h3`
    display: flex;
    gap: 4px;
    align-items: center;
    margin: 0;
    color: #3c464f;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: -0.075px;
`;

export const LegacyNoteList = styled.ol`
    display: flex;
    flex-direction: column;
    gap: 4px;
    counter-reset: item;
    margin: 0;
    padding: 0;
`;

export const LegacyNoteItem = styled.li`
    color: #4f5861;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: -0.065px;
    list-style: none;
    position: relative;
    padding-left: 20px;

    &::before {
        content: counter(item) '. ';
        counter-increment: item;
        position: absolute;
        left: 0;
        color: #949aa1;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 19px;
        letter-spacing: -0.065px;
    }
`;

export const SectionTitle = styled.div`
    margin: 16px 0 12px;
    color: ${COLORS['gray-100']};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

export const ChannelFieldCard = styled.div`
    padding: 14px 16px 14px;
    border-radius: 2px;
    background: ${COLORS['gray-10']};
    margin-top: 0;
`;

export const ListTypeToggle = styled.div`
    display: inline-flex;
    width: 100%;
    min-height: 36px;
    padding: 2px;
    border: 1px solid ${COLORS['gray-25']};
    border-radius: 8px;
    background: ${COLORS['gray-10']};

    button {
        flex: 1;
        min-width: 0;
        border: 0;
        border-radius: 6px;
        background: transparent;
        color: ${COLORS['gray-80']};
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        cursor: pointer;
        transition: background-color 0.15s ease, color 0.15s ease,
            box-shadow 0.15s ease;
    }

    button + button {
        margin-left: 2px;
    }

    button.active {
        color: #1557d9;
        background: #fff;
        box-shadow: none;
    }
`;

export const Divider = styled.div`
    height: 1px;
    background: #e3e7eb;
    margin: 15px 0;
`;

export const FieldRow = styled.div`
    display: grid;
    grid-template-columns: 160px minmax(0, 1fr);
    align-items: center;
    gap: 12px;

    &.full-width {
        grid-template-columns: 1fr;
        align-items: stretch;
    }

    & + & {
        margin-top: 10px;
    }
`;

export const FieldLabel = styled.div`
    color: ${COLORS['gray-100']};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

export const FieldControl = styled.div`
    min-width: 0;
    width: 100%;

    .dropdown-trigger {
        width: 100%;
        justify-content: space-between;
        padding: 0 12px;
        border-radius: 2px;
        min-width: 0;
    }

    .dropdown-text {
        padding-left: 0;
    }
`;

export const ByDropdownWrapper = styled.div`
    position: relative;
    width: 100%;

    .by-dropdown-selected-box {
        width: 100%;
    }

    .by-dropdown-selected-box .selected-box {
        width: 100%;
        padding: 0 12px;
    }

    .by-dropdown-selected-box .selected-box > h1 {
        flex: 1;
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
    }

    .by-dropdown-selected-box .selected-box .arrow-icon {
        flex-shrink: 0;
    }

    .by-dropdown-selected-box .selected-box:hover {
        background: #f7f7f7;
    }

    .by-dropdown-selected-box.is-open .selected-box {
        border-color: #1557d9;
        background: #fff;
    }
`;

export const ChannelDropdownWrapper = styled(ByDropdownWrapper)`
    .channel-dropdown-selected-box {
        width: 100%;
    }

    .channel-dropdown-selected-box .selected-box {
        width: 100%;
        padding: 0 12px;
    }

    .channel-dropdown-selected-box .selected-box:hover {
        background: #f7f7f7;
    }

    .channel-dropdown-selected-box.is-open .selected-box {
        border-color: #1557d9;
        background: #fff;
    }

    .condition-value-checkbox-dropdown .filter-option-item {
        width: 100%;
        height: 36px;
        min-height: 36px;
        padding: 10px 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 0 0 auto;
        text-align: center;
        cursor: pointer;
        background-color: #fff;
        color: #3c464f;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        transition: background-color 0.15s ease, color 0.15s ease;

        &:hover {
            background-color: #f7f7f7;
        }

        p {
            width: 100%;
            margin: 0;
            text-align: center;
            color: inherit;
            font-size: inherit;
            font-weight: inherit;
            line-height: inherit;

            b {
                font-weight: 700;
                word-break: break-word;
            }
        }
    }
`;

export const DropdownBoxTriggerValue = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-width: 0;

    span {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left;
    }
`;

export const DropdownBoxTriggerIcon = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    line-height: 0;

    svg,
    img {
        width: 16px;
        height: 16px;
        display: block;
    }

    svg.marketing,
    svg.organic {
        width: 18px;
        height: 18px;
    }
`;
export const ByOptionItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    width: 100%;

    span {
        flex: 1;
        min-width: 0;
    }

    svg {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
        margin-left: auto;
    }
`;

export const ChannelOptionItem = styled(ByOptionItem)`
    justify-content: flex-start;

    .channel-option-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 auto;
        line-height: 0;
    }

    .channel-option-icon + span {
        flex: 1 1 auto;
        text-align: left;
    }

    .channel-option-icon svg,
    .channel-option-icon img {
        width: 16px;
        height: 16px;
        display: block;
    }

    .channel-option-icon svg.marketing,
    .channel-option-icon svg.organic {
        width: 24px;
        height: 24px;
    }
`;

export const byDropdownCss = css`
    margin-top: 5px;
    border: 1px solid ${COLORS['gray-30']};
    border-radius: 2px;

    .option-item > p {
        width: 100%;
    }
`;

export const channelDropdownCss = byDropdownCss;

export const ByNestedDropdown = styled.div`
    position: fixed;
    background: #fff;
    border: 1px solid ${COLORS['gray-30']};
    border-radius: 2px;
    z-index: 13;

    ul {
        list-style: none;
        margin: 0;
        padding: 4px 0;
        max-height: 350px;
        overflow-y: auto;
        overflow-x: hidden;
    }
`;

export const ByNestedOption = styled('li', { isSelected: Boolean })`
    min-height: 36px;
    display: flex;
    align-items: center;
    padding: 5px 15px;
    color: ${({ isSelected }) =>
        isSelected ? COLORS['blue-60'] : COLORS['gray-100']};
    font-size: 13px;
    font-weight: ${({ isSelected }) => (isSelected ? 600 : 'normal')};
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
`;

export const getChannelNestedDropdownCss = (top) => css`
    position: absolute;
    top: ${top - 10}px;
    left: 218px;
    border: 1px solid ${COLORS['gray-30']};
    border-radius: 2px;

    & > div:has(ul) {
        width: 100%;
    }
`;

export const ChannelDropdownTrigger = styled('div', { hasValue: Boolean })`
    width: 100%;
    min-height: 34px;
    border: 1px solid ${COLORS['gray-30']};
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    background: #fff;
    color: ${({ hasValue }) =>
        hasValue ? COLORS['gray-100'] : COLORS['gray-50']};
    cursor: pointer;
    transition: border-color 0.15s ease, background-color 0.15s ease;

    &:hover {
        background: #f7f7f7;
    }

    &.is-open {
        border-color: #1557d9;
        background: #fff;
    }

    .arrow-icon {
        width: 12px;
        height: 12px;
        fill: ${COLORS['gray-80']};
        flex-shrink: 0;
        transition: transform 0.15s ease;
    }

    &.is-open .arrow-icon {
        transform: rotate(180deg);
    }
`;

export const ChannelTriggerValue = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;

    span {
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const ChannelTriggerIcon = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    line-height: 0;

    svg,
    img {
        width: 16px;
        height: 16px;
        display: block;
    }

    svg.marketing,
    svg.organic {
        width: 24px;
        height: 24px;
    }

    svg.marketing,
    svg.organic {
        width: 18px;
        height: 18px;
    }
`;

export const ChannelOptionLogo = styled.img`
    width: 16px;
    height: 16px;
    border-radius: 2px;
`;

export const ChannelGroupLogo = styled.img`
    width: 24px;
    height: 24px;
    display: block;
    flex-shrink: 0;
`;

export const ListWrapper = styled.div`
    width: 100%;
    background-color: #fff;

    .drag-area {
        height: auto;
    }
`;

export const ListSection = styled('div', { withBorder: Boolean })`
    padding: 8px 16px;
    border-top: ${({ withBorder }) =>
        withBorder ? '1px solid #dfe3e5' : 'none'};
    min-height: 40px;
    max-height: 85px;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
        width: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #cfd5db;
        border-radius: 999px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
`;

export const FieldValueListWrapper = styled(ListWrapper)`
    padding: 8px 16px;
    max-height: 170px;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const FieldValueSummaryWrapper = styled.div`
    display: flex;
    align-items: center;
    min-height: 40px;

    > div {
        margin-top: 0;
        margin-right: 0;
    }
`;

export const FieldValueEditorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    flex: 1;
`;

export const FieldValueEditorBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 0;
    flex: 1;
`;

export const FieldValueActionButton = styled.button`
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border: 1px solid ${COLORS['gray-30']};
    border-radius: 2px;
    background: #fff;
    color: ${COLORS['gray-100']};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;

    .action-icon {
        width: 16px;
        height: 16px;
        fill: ${COLORS['gray-80']};
        flex-shrink: 0;
    }

    &:hover {
        background: #f7f8f9;
    }
`;

export const CTAWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: auto;
    margin-left: -28px;
    margin-right: -28px;
    padding: 16px 28px;
    border-top: 1px solid #d4d8db;
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    background: #fff;
    z-index: 1;
`;

export const CancelActionButton = styled(ActionButton)`
    color: ${COLORS['gray-100']};
    background: unset;

    &:hover,
    &:active {
        background-color: #f7f7f7;
    }
`;

export const ConditionCard = styled.div`
    border-radius: 2px;
    background: #f4f6f8;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const PreviewCard = styled.div`
    border: 1px solid ${COLORS['gray-20']};
    border-radius: 2px;
    overflow: hidden;
`;

export const ConditionTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0 12px;
    color: ${COLORS['gray-100']};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

export const ConditionTitleLeft = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    line-height: 1;

    .info-icon {
        width: 14px;
        height: 14px;
        fill: ${COLORS['gray-50']};
        flex-shrink: 0;
    }
`;

export const ConditionDeleteButton = styled.button`
    border: 0;
    background: transparent;
    color: #1557d9;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 0;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
`;

export const PreviewTitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0 12px;
    color: ${COLORS['gray-100']};
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

export const PreviewActions = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PreviewRefreshButton = styled.button`
    border: 0;
    background: transparent;
    color: #1557d9;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 0;
    cursor: pointer;

    &:disabled {
        color: #9ca5af;
        cursor: default;
    }
`;

export const PreviewMeta = styled.div`
    color: ${COLORS['gray-50']};
    font-size: 12px;
    line-height: 16px;
    padding: 12px 16px 0;
`;

export const PreviewList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-height: 200px;
    overflow-y: auto;
    padding: 12px 16px 16px;
`;

export const PreviewItem = styled.div`
    color: ${COLORS['gray-100']};
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PreviewLoadingMore = styled.div`
    display: flex;
    justify-content: center;
    padding: 4px 0;
`;

export const PreviewItemIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    line-height: 0;

    svg,
    img {
        width: 16px;
        height: 16px;
        display: block;
    }
`;

export const ConditionRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
`;

export const ConditionField = styled.div`
    min-width: 0;
`;

export const ConditionFixedField = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 36px;
    padding: 0 12px;
    border: 1px solid #d7dde3;
    border-radius: 2px;
    color: #080a0d;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    background: #fff;
    cursor: default;
    user-select: none;
`;

export const ConditionTriggerWrapper = styled.div`
    width: 100%;

    .condition-operator-selected-box {
        width: 100%;
    }

    .condition-operator-selected-box .selected-box {
        width: 100%;
        height: 36px;
        padding: 0 12px;
    }

    .condition-operator-selected-box .selected-box > h1 {
        flex: 1;
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
    }

    .condition-operator-selected-box .selected-box .arrow-icon {
        flex-shrink: 0;
    }

    .condition-operator-selected-box .selected-box:hover {
        background: #f7f7f7;
    }

    .condition-operator-selected-box .selected-box .arrow-icon.is-open {
        transform: rotate(180deg);
    }

    .condition-operator-selected-box.is-open .selected-box,
    .condition-operator-selected-box .selected-box.is-open {
        border-color: #1557d9 !important;
        background: #fff !important;
    }
`;

export const ConditionValueRow = styled.div``;

export const ConditionMultiInputWrapper = styled.div`
    width: 100%;

    > div {
        gap: 4px;
        padding: 4px 12px;
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 80px;
        border: 1px solid #d7dde3;
        border-radius: 2px;
        color: #080a0d;
        cursor: pointer;
        transition: border-color 0.2s;
    }

    > div:focus-within {
        border-color: #1557d9;
    }

    .selected-box {
        padding: 7px 12px;
    }

    .selected-box > h1 {
        line-height: 18px;
    }

    .selected-box .arrow-icon {
        position: sticky;
        top: 50%;
        align-self: flex-start;
        margin-top: 13px;
        flex-shrink: 0;
    }

    input {
        cursor: text;
        padding: 0;
        font-size: 13px;
        color: #080a0d;
    }

    input::placeholder {
        color: #6e767d;
        font-weight: 400;
    }

    .condition-multi-input-field {
        max-height: 80px;
        overflow-y: auto;
        align-items: flex-start;
    }

    .condition-multi-input-field .adriel-field-wrapper {
        max-height: 80px;
        overflow-y: auto;
        align-items: flex-start;
    }

    .s-close {
        width: 12px;
        height: 12px;
        fill: #080a0d;
        flex-shrink: 0;
        cursor: pointer;
    }
`;

export const ConditionCheckboxWrapper = styled.div`
    position: relative;
    width: 100%;

    .filter-widget-gray-selected-box:not(.has-values):not(.is-open)
        .selected-box:hover {
        background: #f7f7f7;
    }

    .filter-widget-gray-selected-box.is-open .selected-box:hover {
        background: #fff;
    }

    .filter-widget-gray-selected-box.is-open .selected-box {
        border-color: #1557d9 !important;
        background: #fff;
    }

    .selected-box {
        align-items: flex-start;
        min-height: 37px;
        max-height: 80px;
        height: auto;
        overflow-y: auto;
        padding: 2px 12px 2px;

        h1 {
            flex: 1;
            min-height: 30px;
            line-height: 30px;
            white-space: normal;
            word-break: break-word;
            padding-top: 1px;
        }

        .arrow-icon {
            position: sticky;
            top: 50%;
            align-self: flex-start;
            transform: translateY(-50%);
            margin-top: 0;
        }
    }

    .condition-value-checkbox-dropdown {
        position: fixed;
        width: 320px;
        max-height: 480px;
        overflow-y: auto;
        z-index: 9999;
        border: 1px solid #d7dde3;
        border-radius: 2px;
        background: #ffffff;

        .header {
            display: none;
        }

        .search-bar {
            width: 100%;
            height: 32px;
            border-radius: 2px;
        }

        .filter-option-item {
            width: 100%;
            height: 36px;
            min-height: 36px;
            padding: 10px 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 0 0 auto;
            text-align: center;
            cursor: pointer;
            background-color: #fff;
            color: #3c464f;
            font-size: 13px;
            font-weight: 400;
            line-height: 18px;
            transition: background-color 0.15s ease, color 0.15s ease;

            &:hover {
                background-color: #f7f7f7;
            }

            p {
                width: 100%;
                margin: 0;
                text-align: center;
                color: inherit;
                font-size: inherit;
                font-weight: inherit;
                line-height: inherit;

                b {
                    font-weight: 700;
                    word-break: break-word;
                }
            }
        }
    }
`;

export const ConditionSelectedItemWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

export const ConditionSelectedItem = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-height: 28px;
    max-width: 100%;
    padding: 0 8px;
    border-radius: 2px;
    background: #f3f5f7;

    svg {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
        cursor: pointer;
    }
`;

export const ConditionSelectedContent = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: 0;

    svg,
    img {
        width: 12px;
        height: 12px;
        flex-shrink: 0;
    }
`;

export const ConditionSelectedText = styled.div`
    min-width: 0;
`;

export const ConditionValueLogo = styled.img`
    width: 12px;
    height: 12px;
    object-fit: contain;
`;

export const ConditionInput = styled.input`
    width: 100%;
    height: 36px;
    border: 1px solid #d7dde3;
    border-radius: 2px;
    padding: 0 12px;
    color: ${COLORS['gray-100']};

    &::placeholder {
        color: ${COLORS['gray-60']};
    }
`;

export const ItemBox = styled(C.ItemBox, { isBreakdownChip: Boolean })`
    border-radius: 12px;
    background: ${({ isBreakdownChip }) =>
        isBreakdownChip ? '#fff' : '#dfe3e5'};
    border: ${({ isBreakdownChip }) =>
        isBreakdownChip ? '1px solid #dfe3e5' : 'none'};
    height: 24px;
    max-width: 350px;

    .move {
        margin: 0;
    }

    .item-text {
        color: #4f5861;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .close {
        fill: #4f5861;
        width: 12px;
        height: 12px;
    }
`;
